// Which quote items are "pairable" — sold as a stereo pair, so their is_pair flag
// and qty (pairs, not units) must be confirmed before an offer commits. Used by
// the Quote Ready / Consignment pair-confirmation gate on the assessment page.
//
// An item is pairable if its SUB-category is a speaker type, OR its NAME carries a
// pair/speaker keyword — the keyword arm catches a speaker that was mis-categorised
// or never categorised (sub is null), which is exactly when the qty mistake slips
// through.

import { PAIRABLE_SUBS } from '../../../utils/constants';

// The speaker subs come from the master category list (soldInPairs).
export const SPEAKER_SUBS = PAIRABLE_SUBS;

// Word-bounded so "Repair" doesn't match "pair" and "Monitoring" doesn't match
// "monitor". Case-insensitive.
export const PAIR_KEYWORD = /\b(speakers?|monitors?|pair)\b/i;

export function isPairable(name, sub) {
    return SPEAKER_SUBS.has(sub) || PAIR_KEYWORD.test(name || '');
}

// The pairable subset, shaped for the dialog: [{ idx, itemId, name, is_pair, qty }].
// The caller supplies accessors so this stays free of component internals — nameOf
// resolves the display name, subOf the sub-category, idOf the stable quote_item_id.
export function pairableItems(items, nameOf, subOf, idOf) {
    const list = Array.isArray(items) ? items : [];
    const out = [];
    list.forEach((it, idx) => {
        const name = nameOf(it, idx);
        if (isPairable(name, subOf(it, idx))) {
            out.push({ idx, itemId: idOf(it, idx), name, is_pair: !!it.is_pair, qty: Number(it.qty) || 1 });
        }
    });
    return out;
}
